(() => {
  'use strict';
  const $ = (selector, root = document) => root.querySelector(selector);
  const $$ = (selector, root = document) => [...root.querySelectorAll(selector)];
  const escapeHtml = (value = '') => String(value).replace(/[&<>'"]/g, char => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' }[char]));
  const formatMoney = cents => {
    try { return new Intl.NumberFormat('tr-TR', { style: 'currency', currency: window.PW3?.currency || 'TRY' }).format((Number(cents) || 0) / 100); }
    catch { return `${((Number(cents) || 0) / 100).toFixed(2)} ${window.PW3?.currency || 'TRY'}`; }
  };
  let upsellSyncTimer = null;
  const syncCartUpsells = cart => {
    window.clearTimeout(upsellSyncTimer);
    upsellSyncTimer = window.setTimeout(async () => {
      let snapshot = cart;
      if (!snapshot) {
        try {
          const response = await fetch(`${window.PW3?.cart || '/cart'}.js`, { headers: { Accept: 'application/json' } });
          if (!response.ok) return;
          snapshot = await response.json();
        } catch { return; }
      }
      const ids = new Set((snapshot.items || []).map(item => String(item.variant_id)));
      $$('[data-pw4-cart-upsell]').forEach(card => { card.hidden = ids.has(String(card.dataset.variantId || '')); });
      $$('.pw4-cart__upsell').forEach(section => {
        const cards = $$('[data-pw4-cart-upsell]', section);
        section.classList.toggle('is-empty', cards.length > 0 && cards.every(card => card.hidden));
      });
    }, 70);
  };

  const cartLineMarkup = item => {
    const imageUrl = item.image ? `${item.image}${item.image.includes('?') ? '&' : '?'}width=240` : '';
    const image = imageUrl ? `<img src="${escapeHtml(imageUrl)}" alt="" loading="lazy">` : '';
    const title = escapeHtml((item.product_title || '').split('|')[0].trim());
    return `<article class="pw3-cart-line" data-pw3-cart-line data-key="${escapeHtml(item.key)}"><a href="${escapeHtml(item.url)}" class="pw3-cart-line__image">${image}</a><div class="pw3-cart-line__info"><a href="${escapeHtml(item.url)}">${title}</a><div class="pw3-qty"><button type="button" data-pw3-qty="minus" aria-label="Azalt">−</button><span>${item.quantity}</span><button type="button" data-pw3-qty="plus" aria-label="Artır">+</button></div><button type="button" class="pw3-cart-line__remove" data-pw3-remove>KALDIR</button></div><strong>${formatMoney(item.final_line_price)}</strong></article>`;
  };

  const refreshCart = async () => {
    const response = await fetch(`${window.PW3?.cart || '/cart'}.js`, { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('cart');
    const cart = await response.json();
    $$('[data-pw3-cart-count],[data-pw3-cart-heading-count]').forEach(node => node.textContent = String(cart.item_count));
    $$('[data-pw3-cart-total]').forEach(node => node.textContent = formatMoney(cart.total_price));
    $$('[data-pw3-checkout]').forEach(node => { node.disabled = cart.item_count === 0; });
    const threshold = Number(window.PW3?.freeShippingThreshold || 100000);
    const remaining = Math.max(0, threshold - cart.total_price);
    const progress = Math.min(100, cart.total_price / threshold * 100);
    $$('[data-pw3-shipping-progress]').forEach(node => { node.style.width = `${progress}%`; });
    $$('[data-pw3-shipping-copy]').forEach(node => { node.textContent = remaining <= 0 ? 'ÜCRETSİZ KARGO AÇILDI' : 'ÜCRETSİZ KARGOYA YAKLAŞIYORSUN'; });
    $$('[data-pw3-shipping-value]').forEach(node => { node.textContent = remaining <= 0 ? '' : `${formatMoney(remaining)} KALDI`; });
    const body = $('[data-pw3-cart-body]');
    if (body) body.innerHTML = cart.items.length ? cart.items.map(cartLineMarkup).join('') : '<div class="pw3-cart__empty"><div><p>Sepetin şu anda boş.</p><a href="/collections/all">ALIŞVERİŞE BAŞLA</a></div></div>';
    syncCartUpsells(cart);
    return cart;
  };

  document.addEventListener('click', async event => {
    const bundle = event.target.closest('[data-pw4-bundle-add]');
    if (!bundle) return;
    event.preventDefault();
    const current = Number(bundle.dataset.currentVariant);
    const pair = Number(bundle.dataset.pairVariant);
    if (!current || !pair) return;
    const original = bundle.innerHTML;
    bundle.disabled = true;
    bundle.textContent = 'EKLENİYOR…';
    try {
      const response = await fetch(`${window.PW3?.cartAdd || '/cart/add'}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: current, quantity: 1 }, { id: pair, quantity: 1 }] })
      });
      if (!response.ok) throw new Error('add');
      await refreshCart();
      $('[data-pw3-open="cart"]')?.click();
    } catch {
      const toast = $('[data-pw3-toast]');
      if (toast) { toast.textContent = 'RİTÜEL SEPETE EKLENEMEDİ'; toast.classList.add('is-visible'); window.setTimeout(() => toast.classList.remove('is-visible'), 2200); }
    } finally {
      bundle.disabled = false;
      bundle.innerHTML = original;
    }
  });

  document.addEventListener('submit', event => {
    if (event.target.matches('[data-pw3-add-form]')) window.setTimeout(() => syncCartUpsells(), 420);
  });
  document.addEventListener('click', event => {
    if (event.target.closest('[data-pw3-remove],[data-pw3-qty]')) window.setTimeout(() => syncCartUpsells(), 360);
  });
  const init = () => {
    syncCartUpsells();
    const cartBody = $('[data-pw3-cart-body]');
    if (cartBody && 'MutationObserver' in window) new MutationObserver(() => syncCartUpsells()).observe(cartBody, { childList: true, subtree: true, characterData: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
